import { api } from "./api";

const KEY = "gls_cm_session";

function randomId() {
 if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
 return `${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}

export function getCareMatchSession() {
 let sid = sessionStorage.getItem(KEY);
 if (!sid) {
 sid = randomId();
 sessionStorage.setItem(KEY, sid);
 }
 return sid;
}

export function resetCareMatchSession() {
 const sid = randomId();
 sessionStorage.setItem(KEY, sid);
 return sid;
}

export function clearCareMatchSession() {
 sessionStorage.removeItem(KEY);
}

/** Fire-and-forget. Never blocks UX or surfaces errors. */
export function trackCareMatch(event) {
 try {
 api.post("/care-match/events", { session_id: getCareMatchSession(), ...event }).catch(() => {});
 } catch (e) {
 /* swallow */
 }
}
